import { useStaticQuery, graphql } from "gatsby"
import { ProductInterface } from "../ts/interfaces"
import { Product } from "../checkout/product"
import { getStripeId } from "../utils/stripejs"

export const useProducts = () => {
  const { allSensaiProduct } = useStaticQuery(
    graphql`
      query {
        allSensaiProduct {
          nodes {
            id
            name
            stripeId
            stripeTestId
            slug
            subHeading
            description
            shortDescription
            featuredImage {
              url
              alternativeText
              imageFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
                }
              }
            }
            relatedProductPriceLink
            relatedProducts {
              id
            }
            productBundles {
              product {
                id
              }
              forced
              title
              description
              skipText
            }
            CAD_Discount
            USD_Discount
            outOfStock
            outOfStockCountries
            canUsOnly
            noCoupons
            isPro
            gallery {
              url
              imageFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
    `
  )

  const products: Product[] = []

  allSensaiProduct.nodes.forEach((p: ProductInterface) => {
    products.push(new Product(p))
  })

  return products
}

export const findProduct = (
  strapiProducts: Product[],
  stripeOrStrapiId?: string
) => {
  return !stripeOrStrapiId
    ? null
    : strapiProducts.find((product: Product) => {
        const stripeId = getStripeId(product.stripeId, product.stripeTestId)
        return (
          product.id === "Product:" + stripeOrStrapiId ||
          product.id === stripeOrStrapiId ||
          stripeId === stripeOrStrapiId
        )
      })
}

export const findProductBySku = (strapiProducts: Product[], sku: string) => {
  return strapiProducts.find((product: Product) => {
    return product.stripeProduct?.metadata.SKU === sku
  })
}
